/* eslint-disable max-lines-per-function */
import "./contactus-address-confirmation.scss";

const showNewAddressTextarea = () => {
  const addressAnswersRadios = document.querySelectorAll(".js-address-confirmation-address-answer");
  const newAddressAnswers = [
    "Yes, but ship a replacement to a new address",
    "No, that is not the correct address"
  ];
  const newAddressInputWrapper = document.querySelector(
    ".js-address-confirmation-new-shipping-address"
  );
  const newAddressInput = document.querySelector(
    ".js-address-confirmation-new-shipping-address-input"
  );

  addressAnswersRadios.forEach(radio => {
    radio.addEventListener("change", event => {
      const isEnterNewAddress = newAddressAnswers.includes(event.target.value);
      newAddressInputWrapper.classList.toggle("hidden", !isEnterNewAddress);

      if (isEnterNewAddress) {
        newAddressInput.setAttribute("required", "required");
      } else {
        newAddressInput.removeAttribute("required");
      }
    });
  });
};

const toggleOrderInfo = () => {
  const $toggles = document.querySelectorAll(".js-address-confirmation-toggle-order-info");

  $toggles.forEach($element => {
    const $toggle = $element;
    $toggle.addEventListener("click", () => {
      $toggle.classList.toggle("show-info");
      $toggle.ariaExpanded = !($toggle.ariaExpanded === "true");
    });
  });
};

const validateAddressSelection = () => {
  const checkboxes = document.querySelectorAll(".js-address-confirmation-address-option");
  const customOrderTextarea = document.querySelector(".js-address-confirmation-custom-order");
  const checkboxesSelected = [];
  const countSelectedCheckboxes = () => checkboxesSelected.reduce((acc, curr) => acc + curr, 0);
  const requiredCheckbox = required => {
    checkboxes.forEach(checkbox => {
      if (required && customOrderTextarea.value === "") {
        checkbox.setAttribute("required", "required");
      } else {
        checkbox.removeAttribute("required");
      }
    });
  };

  customOrderTextarea.addEventListener("keydown", event => {
    setTimeout(() => {
      requiredCheckbox(event.target.value === "");
    }, 10);
  });

  checkboxes.forEach((checkbox, idx) => {
    checkbox.addEventListener("change", () => {
      checkboxesSelected[idx] = checkbox.checked;
      requiredCheckbox(countSelectedCheckboxes() === 0);
    });
  });
};

const showRefundNote = () => {
  const addressAnswersRadios = document.querySelectorAll(".js-address-confirmation-address-answer");
  const refundLabel = document.querySelector(".js-address-confirmation-refund-note");
  const refundRadioOption = refundLabel.closest("div").querySelector("input");

  addressAnswersRadios.forEach(radio => {
    radio.addEventListener("change", event => {
      const isRefundOptionSelected = event.target === refundRadioOption;
      refundLabel.classList.toggle("hidden", !isRefundOptionSelected);
    });
  });
};

export default () => {
  showNewAddressTextarea();
  toggleOrderInfo();
  validateAddressSelection();
  showRefundNote();
};
